// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { hasExtractRefreshPermission } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { IWorkbookActions } from '../../../workbook/ServerApi/types/IWorkbookActions';
import { resumeExtractRefresh } from '../../actions/extractRefresh/ResumeExtractRefreshAction';

export const ResumeExtractRefreshEntityAction: IEntityAction<IExtractTaskInfo, IWorkbookActions> = {
  name: EntityActionNames.TasksResumeExtractRefresh,
  translateName: Messages.resumeExtractRefresh_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: resumeExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions) && hasDisabledTasks(tasks);
}

function hasDisabledTasks(
  tasks: IExtractTaskInfo[]
): boolean {
  return tasks.some(task => task.state === 'Disabled' || task.state === 'Suspended');
}
